import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from "react-i18next";
import DateFnsUtils from '@date-io/moment';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker
} from '@material-ui/pickers';
import moment from "moment";
import {useState} from "react";


export default observer(({
    field,
    ...rest
}) => {
    const { t } = useTranslation();
    return <div>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
                fullWidth
                openTo={"year"}
                views={["year", "month", "date"]}
                disableToolbar
                variant="inline"
                margin="normal"
                placeholder="DD.MM.YYYY"
                format="DD.MM.yyyy"
                label={t(field.label)}
                value={field.value || null}
                error={Boolean( field.error) }
                helperText={field.error ? t(field.error) : ""}
                onChange={field.onChange}
                KeyboardButtonProps={{
                    'aria-label': 'change date',
                }}
            />
        </MuiPickersUtilsProvider>
    </div>;
}
);
